import React, { Component } from "react";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-react-buttons/styles/material.css";
import "@syncfusion/ej2-react-popups/styles/material.css";
import DataTable from "react-data-table-component";
import ManageTabSettings from "./ManageTabSettings";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { tokenVerification } from "./Utils";

class ViewSurvey extends Component {
  constructor() {
    super();
    const date = new Date();
    var minute = date.getMinutes();
    if (date.getMinutes() > 0 && date.getMinutes() < 10) {
      minute = "0" + date.getMinutes();
    }
    const showCurrentTime = date.getHours() + ":" + minute;
    var currentDate = new Date();
    var dd = currentDate.getDate() + 1;
    var mm = currentDate.getMonth() + 1;
    var yyyy = currentDate.getFullYear();
    let tomorrow = new Date();
    tomorrow.setDate(currentDate.getDate() + 1);
    const dateVaring =
      currentDate.getMonth() +
      "/" +
      currentDate.getDate() +
      "/" +
      currentDate.getFullYear();
    this.state = {
      selectedHospitalId: "",
      selectedHealthSystemId: "",
      selectedTreatmentId: "",
      selectedServiceLineId: "",
      showLoader: false,
      showQrCode: false,
      showPatientDetailsPopUp: false,
      healthSystemId: "",
      hospitalId: "",
      serviceLineId: "",
      selectedAdmissionDate: currentDate,
      selectedTreatmentDate: "",
      isActive: "schedule",
      data: [
        {
          id: "",
          name: "",
          date: "",
          time: "",
          serviceLine: "",
          procedure: "",
          physician: "",
          admissionDate: "",
          treatmentDate: "",
          admissionTime: "",
          userEmailId: "",
          userPhoneNumber: "",
        },
      ],
      healthSystemGroupValue: [],
      hideTextAreaPopup: false,
      disabled: false,
      editedId: "-1",
      editImageSrc: "./assets/images/edit.svg",
      contentEditable: "false",
      hidden: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      successResp: false,
      admissionTime: showCurrentTime,
      pageNum: null,
      qrCode: "",
      paginationValue: 10,
      healthSystemGroupValue: [],
      hospitalGroupValue: [],
      serviceLineGroupValue: [],
      searchTerm: "",
      isLoading: true,
      noMatchingData: false,
      tableReady: false,
    };
    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.editImageSrc = "./assets/images/edit2.png";
    this.procedureVar = [];
    this.serviceLineVar = [];
    this.physicianVar = [];
    this.proceduresByServiceLine = [];
    this.physiciansByServiceLine = [];

    this.state.selectedHealthSystemId = localStorage.getItem("healthSystemId");
    this.state.selectedHospitalId = localStorage.getItem("hospitalId");
    this.state.selectedServiceLineId = localStorage.getItem("serviceLineId");
    this.userDetails = JSON.parse(localStorage.getItem("user_details"));
    this.healthSystemDropDownInMARef = React.createRef();
    this.hospitalDropDownInMARef = React.createRef();
    this.seriviceLineDropDownInMARef = React.createRef();
  }
  componentDidMount() {
    var thisController = this;
    thisController.state.selectedHealthSystemId =
      localStorage.getItem("healthSystemId");
    thisController.state.selectedHospitalId =
      localStorage.getItem("hospitalId");
    localStorage.setItem("admissions-nav-bar-selection", "manage-admission");

    const savedPage = localStorage.getItem("lastPatientSurveyActivePage");
    if (savedPage !== null) {
      thisController.restoredPage = parseInt(savedPage);
      localStorage.removeItem("lastPatientSurveyActivePage");
    } else {
      thisController.restoredPage = 1;
    }


    var userRole = thisController.userDetails["userRole"];
    if (userRole == "HEALTHSYSTEM_ADMIN") {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.state.selectedHospitalId = localStorage.getItem("hospitalId");
    } else if (
      userRole == "HOSPITAL_ADMIN"
    ) {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.state.selectedHospitalId = thisController.userDetails["hospitalId"];
    } else if (
      userRole == "SERVICELINE_ADMIN" ||
      userRole == "PHYSICIAN"
    ) {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.state.selectedHospitalId = thisController.userDetails["hospitalId"];
      thisController.state.selectedServiceLineId = thisController.userDetails["serviceLineId"];

    } else {
      thisController.state.selectedHealthSystemId =
        localStorage.getItem("healthSystemId");
      thisController.state.selectedHospitalId = localStorage.getItem("hospitalId");
    }
    thisController.setState(thisController.state);
    thisController.fetchHealthSystemDetails();
    var thisController = this;
    // var serviceLinesLoadedPromise = thisController.fetchServiceLines();
    var proceduresLoadedPromise = thisController.fetchProcedures();
    var physicianLoadPromise = thisController.fetchPhysicians();
    Promise.all([
      // serviceLinesLoadedPromise,
      proceduresLoadedPromise,
      physicianLoadPromise,
    ]).then(() => {
      thisController.fetchManageAdmissionDetails();
      thisController.setState(thisController.state);
    });
    setTimeout(() => {
      this.forceUpdate();
    }, 500);

    this.onActiveClick = this.onActiveClick.bind(this);
  }

  notifyFailedLoad(response) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }

  notifyImproperDate() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="/my-jeeva/assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Given date seems to be a past date. Please provide a valid
        Treatment Date
      </b>,
      {
        position: "top-center",
      }
    );
  }

  fetchEpisodeDataApi(row) {
    var fetchDataContoller = this;
    $.ajax({
      url: "/my-jeeva-api/episode",

      method: "GET",
      data: {
        patientId: row.patientId,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          fetchDataContoller.state.showLoader = true;
          fetchDataContoller.state.loadedData = res.result;
          fetchDataContoller.state.disableAddButton = false;
          fetchDataContoller.setState(fetchDataContoller.state);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/my-jeeva-api/login";
        }
      },
    });
  }

  fetchPhysicians = () => {
    var treatmentId = localStorage.getItem("selectedTreatmentId");
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    console.log(
      "The selected Treatment Id for physician is: " +
      thisController.state.selectedTreatmentId
    );

    if (userRole == "HEALTHSYSTEM_ADMIN") {
      this.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      this.state.selectedHospitalId = localStorage.getItem("hospitalId");
    } else if (
      userRole == "HOSPITAL_ADMIN" ||
      userRole == "SERVICELINE_ADMIN" ||
      userRole == "PHYSICIAN"
    ) {
      this.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      this.state.selectedHospitalId = thisController.userDetails["hospitalId"];
    }

    var data = {
      role: "PHYSICIAN",
      healthSystemId: thisController.state.selectedHealthSystemId,
      hospitalId: thisController.state.selectedHospitalId,
    };

    if (treatmentId) {
      data.procedureId = treatmentId;
    }

    if (!treatmentId) {
      return;
    }
    var physicianLoadPromise = new Promise((resolve, reject) => {
      $.ajax({
        url: "/my-jeeva-api/physicians",

        method: "GET",
        data: {
          procedureId: treatmentId
        },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },

        /*  url: "/my-jeeva-api/fetch-provider",
  
                      method: 'GET',
                      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
                      data: {
                          treatmentId:  thisController.state.selectedTreatmentId,
                      },*/

        success: function (res) {
          if (res.success === true) {
            thisController.state.showLoader = true;
            thisController.setState(thisController.state);
            var provider = res.result;
            console.log(provider);
            var noOfProviders = provider.length;
            thisController.physicianVar = [];

            var physiciansByServiceLine = [];
            for (var i = 0; i < noOfProviders; i++) {
              thisController.physicianVar.push(provider[i]);
              if (!physiciansByServiceLine[provider[i].serviceLineId]) {
                physiciansByServiceLine[provider[i].serviceLineId] = [];
              }
              physiciansByServiceLine[provider[i].serviceLineId].push(
                provider[i]
              );
            }
            thisController.physiciansByServiceLine = physiciansByServiceLine;
            if (resolve) {
              resolve();
            }
          } else {
            if (reject) {
              reject();
            }
            // thisController.notifyError(res.result);
          }
        },
        error: function (xhr) {
          if (reject) {
            reject();
          }
          if (xhr.status == 401) {
            window.location.href = "/my-jeeva-api/login";
          }
        },
      });
    });

    return physicianLoadPromise;
  };
  fetchProcedures = () => {
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    var providerId;
    if (userRole == "HEALTHSYSTEM_ADMIN") {
      this.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      this.state.selectedHospitalId = localStorage.getItem("hospitalId");
    } else if (
      userRole == "HOSPITAL_ADMIN" ||
      userRole == "SERVICELINE_ADMIN" ||
      userRole == "PHYSICIAN"
    ) {
      this.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      this.state.selectedHospitalId = thisController.userDetails["hospitalId"];
      providerId = thisController.userDetails["userId"];
    }
    if (userRole == "PHYSICIAN") {
      $.ajax({
        url: "/my-jeeva-api/procedure-treatment",
        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        data: {
          providerId: providerId,
          hospitalId: this.state.selectedHospitalId
        },
        success: function (res) {
          if (res.success === true) {
            // thisController.state.data = res.result;
            thisController.state.disabled = false;
            thisController.state.showLoader = true;

            var procedures = res.result;
            procedures = procedures.filter(procedure => !procedure.isDeactivated);
            console.log(procedures);
            var noOfProcedures = procedures.length;
            thisController.procedureVar = [];
            var proceduresByServiceLine = [];
            for (var i = 0; i < noOfProcedures; i++) {
              thisController.procedureVar.push(procedures[i]);
              if (!proceduresByServiceLine[procedures[i].serviceLineId]) {
                proceduresByServiceLine[procedures[i].serviceLineId] = [];
              }
              proceduresByServiceLine[procedures[i].serviceLineId].push(
                procedures[i]
              );
            }
            thisController.proceduresByServiceLine = proceduresByServiceLine;
            // }
            thisController.setState(thisController.state);
          } else {
            // thisController.notifyError(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            tokenVerification();
          }
        },
      });
    }
    else {
      var fetchProcedurePromise = new Promise((resolve, reject) => {
        $.ajax({
          url: "/my-jeeva-api/fetch-procedure-enrollments",

          method: "GET",
          data: {
            healthSystemId: thisController.state.selectedHealthSystemId,
            hospitalId: thisController.state.selectedHospitalId,
          },

          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
          },
          success: function (res) {
            if (res.success === true) {
              thisController.state.showLoader = true;
              thisController.setState(thisController.state);
              var procedures = res.result;
              procedures = procedures.filter(procedure => !procedure.isDeactivated);
              console.log(procedures);
              var noOfProcedures = procedures.length;
              thisController.procedureVar = [];
              var proceduresByServiceLine = [];

              // if( noOfProcedures > 0 
              //   // && (thisController.state.selectedTreatmentId == "" || thisController.state.selectedTreatmentId != procedures[0].id)
              // ){

              //    localStorage.setItem("selectedTreatmentId", procedures[0].id)
              //     thisController.state.selectedTreatmentId = procedures[0].id;
              //   }

              for (var i = 0; i < noOfProcedures; i++) {
                thisController.procedureVar.push(procedures[i]);

                if (!proceduresByServiceLine[procedures[i].serviceLineId]) {
                  proceduresByServiceLine[procedures[i].serviceLineId] = [];
                }
                proceduresByServiceLine[procedures[i].serviceLineId].push(
                  procedures[i]
                );
              }
              thisController.proceduresByServiceLine = proceduresByServiceLine;
              console.log(
                "Sorted Treatments into these buckets: " + proceduresByServiceLine
              );
              if (resolve) {
                resolve();
              }
            } else {
              if (reject) {
                reject();
              }
              // thisController.notifyError(res.result);
            }
          },
          error: function (xhr) {
            if (reject) {
              reject();
            }
            if (xhr.status == 401) {
              window.location.href = "/my-jeeva-api/login";
            }
          },
        });
      });
      return fetchProcedurePromise;
    }

  };
  addRow = () => {
    var addController = this;
    addController.state.paginationValue =
      addController.state.paginationValue + 5;
    if (addController.state.pageNum != 0) {
      addController.setState({ pageNum: 0 });
    }
    this.state.data.unshift({
      id: "",
      name: "",
      date: "",
      time: "",
      serviceLine: "",
      procedure: "",
      physician: "",
    });
    this.setState({
      data: this.state.data,
      disabled: true,
    });
  };

  CustomNoDataComponent = () => (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <p>There are no patient admission present. </p>
    </div>
  );
  fetchServiceLines = () => {
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];

    if (userRole == "HEALTHSYSTEM_ADMIN") {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.state.selectedHospitalId =
        localStorage.getItem("hospitalId");
    } else if (
      userRole == "HOSPITAL_ADMIN" ||
      userRole == "SERVICELINE_ADMIN" ||
      userRole == "PHYSICIAN"
    ) {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.state.selectedHospitalId =
        thisController.userDetails["hospitalId"];
    }
    if (thisController.state.selectedHospitalId == null || thisController.state.selectedHospitalId == "null") {
      thisController.state.selectedHospitalId = "00000000-0000-0000-0000-000000000000";
      thisController.setState(thisController.state);
    }
    var serviceLineFetchPromise = new Promise((resolve, reject) => {
      $.ajax({
        url: "/my-jeeva-api/service-line",

        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        data: {
          healthSystemId: thisController.state.selectedHealthSystemId,
          hospitalId: thisController.state.selectedHospitalId,
        },
        success: function (res) {
          if (res.success === true) {
            thisController.state.showLoader = true;
            thisController.setState(thisController.state);
            var serviceLine = res.result;
            var noOfServiceLine = serviceLine.length;
            thisController.serviceLineVar = [];
            for (var i = 0; i < noOfServiceLine; i++) {
              thisController.serviceLineVar[i] = serviceLine[i];
            }
            resolve();

          } else {
            if (reject) {
              reject();
            }
            // thisController.notifyError(res.result);
          }
        },
        error: function (xhr) {
          var errorMessage = xhr.status + ": " + xhr.statusText;
          if (xhr.status == 401) {
            tokenVerification();
          }
          if (reject) {
            reject();
          }
        },
      });
    });

    return serviceLineFetchPromise;
  };

  saveDetailsApi(row, e) {
    row.name = document.getElementById("name" + row.id).innerText.trim();
    row.emailId = document.getElementById("emailId" + row.id).innerText.trim();
    var saveController = this;
    this.state.editedId = "-1";
    this.setState(this.state);
    var saveData = {
      userName: row.name,
      healthSystemId: saveController.state.selectedHealthSystemId,
      serviceLineId: document.getElementById("serviceLine").value,
      hospitalId: saveController.state.selectedHospitalId,
      procedureId: document.getElementById("procedureId" + row.id).value,
      userRole: "PATIENT",
      admissionDate: document.getElementById("date" + row.id).innerHTML,
      admissionTime: document.getElementById("time" + row.id).innerHTML,
    };
    var addUserController = this;
    $.ajax({
      url: "/my-jeeva-api/patient",

      method: "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
      },
      data: JSON.stringify(saveData),
      success: function (res) {
        if (res.success === true) {
          addUserController.notifyAdded();
          addUserController.fetchPatientDetails();
          addUserController.setState({ disabled: false });
        } else {
          addUserController.notifyFailedResponse(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "";
        }
      },
    });
  }

  updateDetailsApi(row, e) {
    var thisController = this;

    var userRole = thisController.userDetails["userRole"];
    if (userRole == "HEALTHSYSTEM_ADMIN") {
      this.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      this.state.selectedHospitalId =
        document.getElementById("hospitalId").value;
    } else if (
      userRole == "HOSPITAL_ADMIN" ||
      userRole == "SERVICELINE_ADMIN" ||
      userRole == "PHYSICIAN"
    ) {
      this.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      this.state.selectedHospitalId = thisController.userDetails["hospitalId"];
    } else {
      this.state.selectedHealthSystemId =
        document.getElementById("healthSystemId").value;
      this.state.selectedHospitalId =
        document.getElementById("hospitalDropDown").value;
    }
    row.name = document.getElementById("name" + row.id).innerText.trim();
    console.log("name: ");
    var admitDate = document.getElementById("admissionDate" + row.id).value;
    var admitTime = thisController.state.admissionTime;
    var treatmentDate = document.getElementById("treatmentDate" + row.id).value

    var serviceLineId;
    if (userRole == "PHYSICIAN" || userRole == "SERVICELINE_ADMIN") {
      serviceLineId = JSON.parse(localStorage.getItem("user_details"))["serviceLineId"];
    } else {
      serviceLineId = document.getElementById("serviceLineId" + row.id).value;
    }
    var treatmentName = document.getElementById("procedureId" + row.id).value;
    var physicianId;
    // if (userRole == "PHYSICIAN") {
    //   physicianId = JSON.parse(localStorage.getItem("user_details"))["userId"];
    // } else {
    //   physicianId = document.getElementById("physicianId" + row.id).value;
    // }
    var serviceLineName;
    if (userRole != "PHYSICIAN" && userRole != "SERVICELINE_ADMIN") {
      serviceLineName = document.getElementById("serviceLineId" + row.id)
        .options[
        document.getElementById("serviceLineId" + row.id).selectedIndex
      ].text
    }
    // var physicianName;
    // if (userRole !== "PHYSICIAN") {
    //   physicianName = document.getElementById("physicianId" + row.id).options[
    //     document.getElementById("physicianId" + row.id).selectedIndex
    //   ].text
    // } else {
    //   physicianName = JSON.parse(localStorage.getItem("user_details"))["name"];
    // }

    // var namePattern = new RegExp(/^([a-zA-Z\s])*$/);
    var namePattern = new RegExp(/^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?]+$/);
    var datePattern = new RegExp(
      /^(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d$/
    );
    var timePattern = new RegExp(
      /^([0-1]?[0-9]|2?[0-3]|[0-9])[:\-\/]([0-5][0-9]|[0-9])$/
    );

    if (
      row.name == "" ||
      admitDate == "" ||
      admitTime == "" ||
      serviceLineId == "" ||
      treatmentName == ""
      // physicianName == "" ||
      // physicianName == "No Option"
    ) {
      thisController.notifyEmptyFields();
    } else if (!namePattern.test(row.name)) {
      thisController.notifyImproperName();
    } else if (!datePattern.test(admitDate)) {
      thisController.notifyImproperDateFormat();
    } else if (!timePattern.test(admitTime)) {
      thisController.notifyImproperTimeFormat();
    } else {
      var updatedData = {
        id: row.id,
        userName: row.name,
        // userRole: "PATIENT",
        healthSystemId: thisController.state.selectedHealthSystemId,
        // serviceLineId: document.getElementById("serviceLineId" + row.id).value,
        serviceLineId: serviceLineId,
        serviceLineName: serviceLineName,
        procedureId: document.getElementById("procedureId" + row.id).value,
        procedureName: document.getElementById("procedureId" + row.id).options[
          document.getElementById("procedureId" + row.id).selectedIndex
        ].text,
        hospitalId: thisController.state.selectedHospitalId,
        // physicianId: physicianId,
        // physicianName: physicianName,
        admissionDate: document.getElementById("admissionDate" + row.id).value,
        treatmentDate: treatmentDate,
        admissionTime: thisController.state.admissionTime,
        userPhoneNumber: row.userPhoneNumber,
        userEmailId: row.userEmailId,
      };
      $.ajax({
        url: "/my-jeeva-api/patient-admission",

        method: "PATCH",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
        },
        data: JSON.stringify(updatedData),
        contentType: "application/json; charset=UTF-8",
        success: function (res) {
          if (res.success === true) {
            thisController.state.editedId = "-1";
            thisController.fetchManageAdmissionDetails();
          } else {
            thisController.notifyFailedResponse(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        },
      });
    }
  }

  notifyImproperName() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please provide a valid name
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyImproperDateFormat() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please provide a valid date in mm/dd/yyyy format
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyImproperTimeFormat() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please enter the time in HH:MM format
      </b>,
      {
        position: "top-center",
      }
    );
  }

  deleteDetailApi = (row) => {
    let deleteRowViewController = this.state.data;
    let deleteApiViewController = this;
    var deleteConstructorVariables = this;

    if (row.id == "") {
      deleteApiViewController.setState({ deleteRow: true });
      deleteConstructorVariables.setState({ hideDeletePopup: false });
      deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
      deleteRowViewController.splice(row.id, 1);
    } else {
      $.ajax({
        url: "/my-jeeva-api/delete-patient-admission",
        data: {
          id: row.id,
          userEmailId: row.userEmailId
        },
        method: "POST",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        success: function (res) {
          if (res.success === true) {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteRowViewController.splice(row.id, 1);
            deleteApiViewController.refreshData();
          } else {
            // deleteApiViewController.notifyError();
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        },
      });
    }

    if (this.state.deleteRow) {
      this.state.data.splice(row.id, 1);
    }
    deleteConstructorVariables.fetchManageAdmissionDetails();
  };
  makeCelledit(row, e) {
    var dateObject = new Date(row.admissionDate);
    this.state.selectedAdmissionDate = dateObject;
    var timeObject = row.admissionTime;
    this.state.admissionTime = timeObject;
    console.log(timeObject);
    this.setState(this.state);
    this.markAsBeingEdited(row.id, timeObject);
    localStorage.setItem("selectedTreatmentId", row.procedureId);
    this.fetchPhysicians();

  }

  markAsBeingEdited(id, timeObject) {
    this.state.editedId = id;
    this.state.admissionTime = timeObject;
    var stateObj = this.state;
    this.setState(stateObj);
  }
  notifyError() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Oops! Error occurred.Please try again
      </b>,
      {
        position: "top-center",
      }
    );
  }

  fetchManageAdmissionDetails = () => {
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    if (userRole == "HEALTHSYSTEM_ADMIN") {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
    } else if (
      userRole == "HOSPITAL_ADMIN"
    ) {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.state.selectedHospitalId =
        thisController.userDetails["hospitalId"];
    } else if (
      userRole == "SERVICELINE_ADMIN" ||
      userRole == "PHYSICIAN"
    ) {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.state.selectedHospitalId =
        thisController.userDetails["hospitalId"];
      thisController.state.selectedServiceLineId = thisController.userDetails["serviceLineId"];
    }
    thisController.setState(thisController.state);
    if (userRole !== "PHYSICIAN") {
      $.ajax({
        url: "/my-jeeva-api/fetch-patient-admissions",
        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        data: {
          healthSystemId: thisController.state.selectedHealthSystemId,
          hospitalId: thisController.state.selectedHospitalId,
          serviceLineId: thisController.state.selectedServiceLineId
        },
        success: function (res) {
          if (res.success === true) {
            var userRole = thisController.userDetails["userRole"];
            var userId = thisController.userDetails["userId"]
            thisController.state.showLoader = true;
            thisController.state.isLoading = false;
            thisController.state.pageNum = thisController.restoredPage || 1;
            thisController.state.tableReady = true;
            thisController.setState(thisController.state);
            var admissionData = res.result;
            thisController.state.data = admissionData;
            thisController.setState(thisController.state)

          } else {
            thisController.notifyFailedLoad(res.result);
          }
        },
        error: function (xhr, status, error) {
          var errorMessage = xhr.status + ": " + xhr.statusText;
          if (xhr.status == 401) {
            tokenVerification();
          }
        },
      });
    } else {
      $.ajax({
        url: "/my-jeeva-api/fetch-provider-admissions",
        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        data: {
          providerId: thisController.userDetails["userId"]

        },
        success: function (res) {
          if (res.success === true) {
            thisController.state.showLoader = true;
            thisController.state.isLoading = false;
            thisController.state.pageNum = thisController.restoredPage || 1;
            thisController.state.tableReady = true;
            thisController.setState(thisController.state);
            var admissionData = res.result;
            thisController.state.data = admissionData;
            thisController.setState(thisController.state);
          }
          else {
            thisController.notifyFailedLoad(res.result);
          }
        },
        error: function (xhr, status, error) {
          var errorMessage = xhr.status + ": " + xhr.statusText;
          if (xhr.status == 401) {
            tokenVerification();
          }
        },
      });
    }

  };

  refreshData = (id) => {
    var refreshContent = this;
    refreshContent.state.editedId = id;
    refreshContent.state.data = [];
    refreshContent.state.isLoading = true;
    refreshContent.state.noMatchingData = false;
    refreshContent.state.searchTerm = "";
    console.log("refreshed");
    refreshContent.setState(refreshContent.state);
    this.setState({
      disabled: false,
      data: [],
    });
    this.fetchManageAdmissionDetails();
  };

  notifyUpdate() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Patient details updated successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyDelete() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Patient Detail deleted successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyEmptyFields() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please fill all the fields before saving
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyFailedResponse(response) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }

  onPageChange = (e) => {
    this.restoredPage = e;
    this.setState({ pageNum: e });
    localStorage.setItem("lastPatientSurveyActivePage", e);
  };

  notifyFailedDelete(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }

  fetchHealthSystemDetails() {
    var thisController = this;
    var responseData = [];
    $.ajax({
      url: "/my-jeeva-api/health-system",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.showLoader = true;
          thisController.setState(thisController.state);
          responseData = res.result;
          var totalCount = responseData.length;
          thisController.state.healthSystemGroupValue = [];
          for (var i = 0; i < totalCount; i++) {
            thisController.state.healthSystemGroupValue.push({
              name: res.result[i].name,
              value: res.result[i].id,
            });
          }

          thisController.setState(thisController.state);

          if (!thisController.state.selectedHealthSystemId) {
            var healthSystemsDropDownList = thisController.healthSystemDropDownInMARef.current
            if (healthSystemsDropDownList) {
              thisController.state.selectedHealthSystemId = healthSystemsDropDownList.value;
              // setTimeout(() => { thisController.onHealthSystemChange({ target: thisController.healthSystemDropDownInMARef.current }) }, 100);
            } else {
              thisController.state.selectedHealthSystemId = res.result[0].id;
            }
          }
          var selectBox = thisController.healthSystemDropDownInMARef.current;
          if (selectBox && selectBox.selectedIndex >= 0) {
            thisController.onHealthSystemChange({ target: selectBox });
          }
          // thisController.fetchHospitalDetails();
        } else {
          thisController.notifyFailedLoad(res.result);
        }
      },
      error: function (xhr, status, error) {
        var errorMessage = xhr.status + ": " + xhr.statusText;
        if (xhr.status == 401) {
          tokenVerification();
        }
      },
    });
  }

  fetchHospitalDetails() {
    var thisController = this;
    var responseData = [];
    var userRole = thisController.userDetails["userRole"];
    if (userRole != "HEALTHSYSTEM_ADMIN" && userRole != "ADMIN") {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.setState(thisController.state);
    } else {
      this.state.selectedHealthSystemId =
        thisController.state.selectedHealthSystemId;
      thisController.setState(thisController.state);
    }
    $.ajax({
      url: "/my-jeeva-api/hospital",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        healthSystemId: thisController.state.selectedHealthSystemId,
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.showLoader = true;
          thisController.setState(thisController.state);
          responseData = res.result;
          var totalCount = responseData.length;
          thisController.state.hospitalGroupValue = [];
          for (var i = 0; i < totalCount; i++) {
            thisController.state.hospitalGroupValue.push({
              name: res.result[i].name,
              value: res.result[i].id,
            });
          }

          thisController.setState(thisController.state);

          if (!thisController.state.selectedHospitalId) {
            thisController.state.selectedServiceLineId = null;
            // thisController.setState(thisController.state);
            var hospitalsDropDownList = thisController.hospitalDropDownInMARef.current
            if (hospitalsDropDownList) {
              thisController.state.selectedHospitalId = hospitalsDropDownList.value;
              // setTimeout(() => { thisController.onHealthSystemChange({ target: thisController.healthSystemDropDownInMARef.current }) }, 100);
            } else {
              thisController.state.selectedHospitalId = res.result[0].id;
            }
          }
          var selectBox = thisController.hospitalDropDownInMARef.current;
          if (selectBox && selectBox.selectedIndex >= 0) {
            thisController.onHospitalChange({ target: selectBox });
          }
          // thisController.fetchHospitalDetails();
        } else {
          thisController.notifyFailedLoad(res.result);
        }
      },
      error: function (xhr, status, error) {
        var errorMessage = xhr.status + ": " + xhr.statusText;
        if (xhr.status == 401) {
          tokenVerification();
        }
      },
    });
  }

  fetchServiceLineDetails() {
    var responseData = [];
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    var healthSystemId;
    var hospitalId;
    if (userRole == "HEALTHSYSTEM_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.state.selectedHospitalId;
    } else if (userRole == "HOSPITAL_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
    } else {
      healthSystemId = thisController.state.selectedHealthSystemId;
      hospitalId = thisController.state.selectedHospitalId;
    }
    if (hospitalId == "null" || hospitalId == null) {
      hospitalId = "00000000-0000-0000-0000-000000000000";
    }
    $.ajax({
      url: "/my-jeeva-api/service-line",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        healthSystemId: healthSystemId,
        hospitalId: hospitalId,
      },
      success: function (res) {
        if (res.success === true) {

          thisController.state.showLoader = true;
          thisController.setState(thisController.state);
          responseData = res.result;
          var totalCount = responseData.length;
          thisController.state.serviceLineGroupValue = [];
          for (var i = 0; i < totalCount; i++) {
            thisController.state.serviceLineGroupValue.push({
              name: res.result[i].name,
              value: res.result[i].id,
            });
          }

          thisController.setState(thisController.state);

          if (!thisController.state.selectedServiceLineId) {
            if (totalCount > 0) {
              thisController.state.selectedServiceLineId = res.result[0].id;
              setTimeout(() => { thisController.onServiceLineChange({ target: thisController.seriviceLineDropDownInMARef.current }) }, 100);
            } else {
              thisController.state.selectedServiceLineId = "00000000-0000-0000-0000-000000000000";
            }
          }
          thisController.setState(thisController.state);
          // var serviceLinesLoadedPromise = thisController.fetchServiceLines();
          var proceduresLoadedPromise = thisController.fetchProcedures();
          var physicianLoadPromise = thisController.fetchPhysicians();
          Promise.all([
            // serviceLinesLoadedPromise,
            proceduresLoadedPromise,
            physicianLoadPromise,
          ]).then(() => {
            thisController.fetchManageAdmissionDetails();
          });

        } else {
          thisController.notifyFailedLoad(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          tokenVerification();
        }
      },
    });
  }

  onHealthSystemChange = (e) => {
    var selectBox = e.target;
    this.state.data = [];
    this.state.isLoading = true;
    this.state.dontOverLap = true;
    localStorage.setItem("serviceName", null);
    if (this.state.selectedHealthSystemId != selectBox.value) {
      this.state.selectedHospitalId = null;
      localStorage.setItem(`hospitalName`, null);
    }
    this.state.selectedHealthSystemId = selectBox.value;
    localStorage.setItem("healthSystemId", this.state.selectedHealthSystemId);
    if (selectBox.value != "") {
      localStorage.setItem("healthSystemName", selectBox.options[selectBox.selectedIndex].innerText);
    }
    this.setState(this.state);
    window.reportsNavBarController.paintPatientAdmissionHeading();
    this.fetchHospitalDetails();
  };

  onHospitalChange = (e) => {
    var selectBox = e.target;
    this.state.data = [];
    this.state.isLoading = true;
    if (this.state.selectedHospitalId != selectBox.value) {
      this.state.selectedServiceLineId = null;
      localStorage.setItem(`hospitalName`, null);
    }
    this.state.selectedHospitalId = selectBox.value;
    localStorage.setItem("hospitalId", this.state.selectedHospitalId);
    if (selectBox.value != "") {
      localStorage.setItem("hospitalName", selectBox.options[selectBox.selectedIndex].innerText);
    }
    this.setState(this.state);
    window.reportsNavBarController.paintPatientAdmissionHeading();


    var thisController = this;
    thisController.fetchServiceLineDetails();
  };

  onServiceLineChange = (e) => {
    var selectBox = e.target;
    this.state.data = [];
    this.state.isLoading = true;
    if (this.state.selectedServiceLineId != selectBox.value) {
      localStorage.setItem(`serviceLineName`, null);
    }
    this.state.selectedServiceLineId = selectBox.value;
    localStorage.setItem("serviceLineId", this.state.selectedServiceLineId);
    if (selectBox.value != "") {
      localStorage.setItem("serviceLineName", selectBox.options[selectBox.selectedIndex].innerText);
    }
    this.setState(this.state);
    window.reportsNavBarController.paintPatientAdmissionHeading();
    var thisController = this;

    // var serviceLinesLoadedPromise = thisController.fetchServiceLines();
    var proceduresLoadedPromise = thisController.fetchProcedures();
    var physicianLoadPromise = thisController.fetchPhysicians();

    Promise.all([
      // serviceLinesLoadedPromise,
      proceduresLoadedPromise,
      physicianLoadPromise,
    ]).then(() => {
      thisController.fetchManageAdmissionDetails();
    });
  };


  showPatientDetails = (row, e) => {
    // this.state.showPatientDetailsPopUp = true;
    // this.state.patientId = row.id;
    localStorage.setItem("selectedTreatmentId", row.procedureId);
    localStorage.setItem("patientProcedureId", row.procedureId);
    localStorage.setItem("patientId", row.patientId);
    localStorage.setItem("patientAddmissionId", row.id);
    localStorage.setItem("activeTabOnLoad", "schedule");
    this.setState({
      showPatientDetailsPopUp: true,
      patientId: row.patientId,
      isActive: "schedule",
    });
    this.props.history.push("/projectmgmt/patient-admission/manage-admission");
  };
  onActiveClick(active) {
    this.setState({ onActive: active });
  }

  qrCodeHandleChange = (row) => {
    this.state.patientId = row.patientId;
    this.setState(this.state);
  };
  handleChangeAdmissionTime = (e) => {
    this.state.admissionTime = e.target.value;
    this.setState(this.state);
  };



  fetchIntentNamesApi() {
    var fetchDataContoller = this;
    var responseData = [];
    $.ajax({
      url: "/my-jeeva-api/intent-names",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        treatmentId: localStorage.getItem("selectedTreatmentId")
      },
      success: function (res) {
        if (res.success === true) {
          fetchDataContoller.state.showLoader = true;
          fetchDataContoller.setState(fetchDataContoller.state);
          var response = res.result;
          var length = response.length;
          fetchDataContoller.loadedIntentNameInfo = [];

          for (var i = 0; i < length; i++) {
            fetchDataContoller.loadedIntentNameInfo[i] = response[i];
          }
        } else {
          fetchDataContoller.notifyFailedLoad(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/my-jeeva-api/login";
        }
      },
    });
  }
  closePatientDataPopUp = () => {
    this.setState({ showPatientDetailsPopUp: false, isActive: "schedule" });
    localStorage.setItem("last-project-manage-tab", "episodes");
    // this.refreshData();
    this.props.history.push({
      pathname: "/projectmgmt/patient-admission",
    });
  };
  closeQrCodePage = () => {
    this.setState({ showQrCode: false });
  };
  onAdmissionDateChange = (date) => {
    this.state.selectedAdmissionDate = date;
    this.setState(this.state);
  };
  onTreatmentDateChange = (date) => {
    var onTreatmentDate = new Date(date);
    var todayDate = new Date();
    if (onTreatmentDate < todayDate) {
      this.notifyImproperDate();
    } else {
      this.state.selectedTreatmentDate = onTreatmentDate;
      this.setState(this.state);
    }

  };
  onChangeOfServiceLine = (row, e) => {
    row.userName = document.getElementById("name" + row.id).innerText;
    row.userPhoneNumber = document.getElementById("date" + row.id).innerText;
    row.userEmailId = document.getElementById("time" + row.id).innerText;
    row.serviceLineId = document.getElementById("serviceLineId" + row.id).value;
    row.serviceLineName = document.getElementById(
      "serviceLineId" + row.id
    ).options[
      document.getElementById("serviceLineId" + row.id).selectedIndex
    ].text;
    row.serviceLineId = e.target.value;
    localStorage.setItem("selectedTreatmentId", this.proceduresByServiceLine[e.target.value][0].id);
    this.fetchProcedures();
    this.fetchPhysicians();
    this.setState(this.state);
  };

  onChangeOfProcedure = (row, e) => {
    var userRole = JSON.parse(localStorage.getItem("user_details"))["userRole"];
    row.userName = document.getElementById("name" + row.id).innerText;
    row.userPhoneNumber = document.getElementById("date" + row.id).innerText;
    row.userEmailId = document.getElementById("time" + row.id).innerText;
    if (userRole == "PHYSICIAN" || userRole == "SERVICELINE_ADMIN") {
      row.serviceLine = JSON.parse(localStorage.getItem("user_details"))["serviceLineId"];
    } else {
      row.serviceLine = document.getElementById("serviceLineId" + row.id).value;
    }

    row.procedureId = document.getElementById("procedureId" + row.id).value;
    row.procedureName = document.getElementById("procedureId" + row.id).options[
      document.getElementById("procedureId" + row.id).selectedIndex
    ].text;
    // row.procedureId = e.target.value;
    console.log(row.procedureId);
    localStorage.setItem("selectedTreatmentId", row.procedureId);
    this.state.selectedTreatmentId = row.procedureId;
    this.setState(this.state);
    this.fetchPhysicians();
    // this.setState(this.state);
  };

  onChangeOfPhysician = (row, e) => {
    var userRole = this.userDetails["userRole"];
    row.userName = document.getElementById("name" + row.id).innerText;
    row.userPhoneNumber = document.getElementById("date" + row.id).innerText;
    row.userEmailId = document.getElementById("time" + row.id).innerText;
    if (userRole == "PHYSICIAN" || userRole == "SERVICELINE_ADMIN") {
      row.serviceLineId = JSON.parse(localStorage.getItem("user_details"))["serviceLineId"];
    } else {
      row.serviceLineId = document.getElementById("serviceLineId" + row.id).value;
    }
    row.procedureId = document.getElementById("procedureId" + row.id).value;
    row.physicianId = document.getElementById("physicianId" + row.id).value;
    row.physicianName = document.getElementById("physicianId" + row.id).options[
      document.getElementById("physicianId" + row.id).selectedIndex
    ].text;
    row.physicianId = e.target.value;
    this.setState(this.state);
  };

  openDeletePopUp = (row) => {
    confirmAlert({
      title: "Confirm to Delete",
      message: "Are you sure to delete this? ",
      buttons: [
        {
          label: "Yes",
          onClick: () => this.deleteDetailApi(row),
        },
        {
          label: "No",
        },
      ],
    });
  };
  handleTabChange(tab) {
    var thisController = this;
    thisController.state.isActive = tab;
    thisController.setState(thisController.state);
  }

  showPatientSurvey = (row, e) => {
    localStorage.setItem("patientAddmissionId", row.id);
    localStorage.setItem("patientProcedureId", row.procedureId);
    localStorage.setItem("surveyPatientName", row.userName);
    const pageToSave = this.state.pageNum || 1;
    localStorage.setItem("lastPatientSurveyActivePage", pageToSave);
    this.props.history.push({
      pathname: "/projectmgmt/view-patient-survey",
    });
  }



  caseInsensitiveSort = (field) => (rowA, rowB) => {

    if (rowA[field] != null && rowB[field] != null) {
      var a = rowA[field].toLowerCase();
      var b = rowB[field].toLowerCase();
    }
    if (a > b) {
      return 1;
    }

    if (b > a) {
      return -1;
    }

    return 0;
  };

  getColoumns() {
    var userRole = JSON.parse(localStorage.getItem("user_details"))["userRole"];
    const columns = [
      {
        name: <b style={{ fontSize: "16px" }}>Name</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('userName'),
        selector: (row) => (
          <div name="name">
            <div
              className="textarea"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                border:
                  row.id == "" || row.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: row.id == "" ? "2px" : "none",
              }}
              id={"name" + row.id}
              contentEditable={
                !(row.id == "" ? false : row.id != this.state.editedId)
                  ? "plaintext-only"
                  : false
              }
            >
              {row.userName}
            </div>
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Date</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('admissionDate'),
        selector: (row) => (
          <div name="date">
            <div
              className="textarea"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                border:
                  row.id === "" || row.id === this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: row.id === "" ? "2px" : "none",
                display: row.id === this.state.editedId ? "none" : "block",
              }}
              id={"date" + row.id}
              contentEditable={
                !(row.id === "" ? false : row.id !== this.state.editedId)
                  ? "plaintext-only"
                  : false
              }
            >
              {row.admissionDate}
            </div>
            {row.id === this.state.editedId && (
              <DatePicker
                style={{
                  width: "10px",
                  marginLeft: "70%",
                  cursor: "pointer",
                }}
                portalId="root"
                autoOk={true}
                id={"admissionDate" + row.id}
                selected={this.state.selectedAdmissionDate}
                onChange={this.onAdmissionDateChange}
                dateFormat="MM/dd/yyyy"
              />
            )}
          </div>
        ),
      },

      {
        name: <b style={{ fontSize: "16px" }}>Time</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('admissionTime'),
        selector: (row) => (
          <div name="time">
            <div
              className="textarea"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                border:
                  row.id === "" || row.id === this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                display: row.id === this.state.editedId ? "none" : "block",
              }}
              id={"time" + row.id}
              contentEditable={
                !(row.id === "" ? false : row.id !== this.state.editedId)
                  ? "plaintext-only"
                  : false
              }
            >
              {row.admissionTime}
            </div>
            {row.id === this.state.editedId && (
              <input
                type="time"
                className="form-control col-11"
                id="admissionTime"
                name="time"
                placeholder="Enter Time"
                value={this.state.admissionTime}
                style={{
                  width: "95%",
                  cursor: "pointer",
                  border: "1px solid #D2D4DC",
                  borderRadius: "4px",
                }}
                onChange={this.handleChangeAdmissionTime}
              />
            )}
          </div>
        ),
      },
      // {
      //   name: <b style={{ fontSize: "16px" }}>Treatment Date</b>,
      //   selector: (row) => (
      //     <div name="date">
      //       <div
      //         className="textarea"
      //         style={{
      //           background: "white",
      //           height: "2.7em",
      //           resize: "none",
      //           paddingLeft: "2px",
      //           paddingTop: "6px",
      //           width: "100%",
      //           border:
      //             row.id === "" || row.id === this.state.editedId
      //               ? "1px solid #D2D4DC"
      //               : "none",
      //           borderRadius: row.id === "" ? "2px" : "none",
      //           display: row.id === this.state.editedId ? "none" : "block",
      //         }}
      //         id={"date" + row.id}
      //         contentEditable={
      //           !(row.id === "" ? false : row.id !== this.state.editedId)
      //             ? "plaintext-only"
      //             : false
      //         }
      //       >
      //         {row.treatmentDate}
      //       </div>
      //       {row.id === this.state.editedId && (
      //         <DatePicker
      //           style={{
      //             width: "10px",
      //             marginLeft: "70%",
      //             cursor: "pointer",
      //           }}
      //           portalId="root"
      //           autoOk={true}
      //           id={"treatmentDate" + row.id}
      //           selected={this.state.selectedTreatmentDate}
      //           onChange={this.onTreatmentDateChange}
      //           dateFormat="MM/dd/yyyy"
      //         />
      //       )}
      //     </div>
      //   ),
      // },
      // {
      //   name: <b style={{ fontSize: "16px", display: userRole == "PHYSICIAN" ? "none" : "block" }}>Service Line</b>,
      //   sortable: true,
      //   sortFunction: this.caseInsensitiveSort('serviceLineName'),
      //   selector: (row) => {
      //     const isEditing = row.id === this.state.editedId;
      //     const element = isEditing ? (
      //       <select
      //         className="input-group form-control select2 "
      //         onChange={(e) => this.onChangeOfServiceLine(row, e)}
      //         value={row.serviceLineId}
      //         id={"serviceLineId" + row.id}
      //         style={{
      //           display: userRole == "PHYSICIAN" ? "none" : "block",
      //           marginLeft: "0vw",
      //           padding: "0px",
      //           paddingTop: "5px",
      //           paddingLeft: "5px",
      //           background: "white",
      //           border: "1px solid #D2D4DC",
      //           borderRadius: "2px",
      //         }}
      //       >
      //         {this.serviceLineVar.map((serviceLineData) => (
      //           <option key={serviceLineData} value={serviceLineData["id"]}>
      //             {serviceLineData["name"]}
      //           </option>
      //         ))}
      //       </select>
      //     ) : (
      //       <div
      //         className="textarea"
      //         style={{
      //           background: "white",
      //           height: "2.7em",
      //           resize: "none",
      //           paddingLeft: "2px",
      //           paddingTop: "6px",
      //           width: "100%",
      //           border: "none",
      //           overflow: "hidden",
      //           display: userRole == "PHYSICIAN" ? "none" : "block",
      //         }}
      //       >
      //         {row.serviceLineName}
      //       </div>
      //     );
      //     return (
      //       <div className="container-fluid" style={{ textAlign: "left" }}>
      //         {element}
      //       </div>
      //     );
      //   },
      // },

      {
        name: <b style={{ fontSize: "16px" }}>Treatment</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('procedureName'),
        selector: (row) => {
          const isEditing = row.id === this.state.editedId;
          const element = isEditing ? (
            <select
              className="input-group form-control select2 "
              onChange={(e) => this.onChangeOfProcedure(row, e)}
              value={row.procedureId}
              id={"procedureId" + row.id}
              style={{
                marginLeft: "0vw",
                padding: "0px",
                paddingTop: "5px",
                paddingLeft: "5px",
                background: "white",
                border: "1px solid #D2D4DC",
                borderRadius: "2px",
              }}
            >
              {this.proceduresByServiceLine[row.serviceLineId] ? (



                this.proceduresByServiceLine[row.serviceLineId].map(
                  (procedureData) => (
                    <option key={procedureData} value={procedureData["id"]}>
                      {procedureData["name"]}
                    </option>
                  )
                )
              )
                : (
                  <option key="" value="">
                    No Option
                  </option>
                )}
            </select>
          ) : (
            <div
              className="textarea"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                border: "none",
                overflow: "hidden",
              }}
            >
              {row.procedureName}
            </div>
          );
          return (
            <div className="container-fluid" style={{ textAlign: "left" }}>
              {element}
            </div>
          );
        },
      },

      {
        name: <b style={{ fontSize: "16px" }}>Provider</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('physicianName'),
        selector: (row) => {
          <div
            className="textarea"
            style={{
              background: "white",
              height: "2.7em",
              resize: "none",
              paddingLeft: "2px",
              paddingTop: "6px",
              width: "100%",
              border: "none",
              overflow: "hidden",
            }}
          >
            {row.physicianName}
          </div>
          return (
            <div className="container-fluid" style={{ textAlign: "left" }}>
              {row.physicianName}
            </div>
          );
        },
      },

      {
        name: (
          <div Align="center">
            <b style={{ fontSize: "16px" }}>Action</b>
          </div>
        ),
        selector: (row) => (
          <div id="action" Align="">
            <div
              className="row"
              style={{
                display: "flex",
                alignItems: "center",
                //justifyContent: "center",
              }}
            >

              <div >
                <button
                  style={{
                    backgroundColor: "#ffffff",
                    border: "none",
                    padding: "2px",
                    width: "3vw",
                    margin: "0.5vw",
                  }}
                  title="View Results"
                >
                  <img
                    className="img-responsive"
                    src={"./assets/images/eye.png"}
                    style={{
                      marginTop: "6px",
                      backgroundColor: "#282a65",
                      borderRadius: "5px",
                      padding: "1px",
                      padding: "3px",
                      height: "3.5vh"
                    }}
                    onClick={(e) =>
                      this.showPatientSurvey(row, e)
                    }
                  />
                </button>
              </div>
            </div>
          </div>
        ),
      },
    ];
    if (userRole == "PHYSICIAN") {
      columns.splice(4, 1)
    }

    return columns;
  }

  handleSearch = (event) => {
    var thisController = this;
    var searchTerm = event.target.value;
    thisController.state.searchTerm = searchTerm;
    thisController.state.isLoading = true;
    thisController.state.data = [];
    thisController.setState(thisController.state);

    var userRole = thisController.userDetails["userRole"];
    if (userRole == "HEALTHSYSTEM_ADMIN") {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
    } else if (
      userRole == "HOSPITAL_ADMIN"
    ) {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.state.selectedHospitalId =
        thisController.userDetails["hospitalId"];
    } else if (
      userRole == "SERVICELINE_ADMIN" ||
      userRole == "PHYSICIAN"
    ) {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
      thisController.state.selectedHospitalId =
        thisController.userDetails["hospitalId"];
      thisController.state.selectedServiceLineId = thisController.userDetails["serviceLineId"];
    }
    thisController.setState(thisController.state);

    $.ajax({
      url: "/my-jeeva-api/search-patient-admissions",

      method: "GET",
      data: {
        healthSystemId: thisController.state.selectedHealthSystemId,
        hospitalId: thisController.state.selectedHospitalId,
        serviceLineId: thisController.state.selectedServiceLineId,
        searchTerm: thisController.state.searchTerm
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },

      success: function (res) {
        if (res.success === true) {
          if (res.result.length > 0) {
            thisController.state.data = [];
            thisController.setState(thisController.state);
            thisController.state.data = res.result;
            thisController.state.noMatchingData = false;
            thisController.state.isLoading = false;
            thisController.setState(thisController.state);
          } else {
            thisController.state.noMatchingData = true;
            thisController.setState(thisController.state);
          }
        }
      },
      error: function (xhr) {

      },
    });

  };

  clearSearchData = () => {
    var thisController = this;
    thisController.setState({ searchTerm: "" }, () => {
      thisController.fetchManageAdmissionDetails();
    });
  }

  render() {
    let defaultActiveTab = "schedule";
    const { data } = this.state;
    var userRole = JSON.parse(localStorage.getItem("user_details"))["userRole"];


    return (
      <div style={{ marginRight: "1%" }} id="manageAdmissionTab">
        <div
          style={{
            background: "#F9F9FB",
            display: this.state.showLoader ? "block" : "none",
          }}
        >
          <link rel="stylesheet" href="assets/css/ReactToastify.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />

          <link rel="stylesheet" href="assets/css/ReactToastify.css" />
          <link href="assets/css/ej2-base.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="assets/css/screenResolution.css" rel="stylesheet" />
          <link
            rel="shortcut icon"
            type="image/png"
            href="assets/images/bot.ico"
          />
          <title> Dheeyantra | BackEnd Api </title>
          <link
            rel="stylesheet"
            href="plugins/font-awesome/css/font-awesome.min.css"
          />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/toggleButton.css" />
          <link
            rel="stylesheet"
            href="assets/css/React_Table_CSS/react-table.css"
          />
          <link href="assets/css/ej2-base.css" rel="stylesheet" />
          <link href="assets/images/edit.svg" rel="stylesheet" />
          <link href="assets/images/add.svg" rel="stylesheet" />
          <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="assets/css/screenResolution.css" rel="stylesheet" />
          <link href="assets/css/menu-drop-down.css" rel="stylesheet" />
          <link
            href="StyleSheet.css"
            rel="stylesheet"
            type="text/css"
            media="only screen"
          />
          <link
            href="MobileStyleSheet.css"
            rel="stylesheet"
            type="text/css"
            media="only screen and (max-device-width: 480px) , only screen and (-webkit-min-device-pixel-ratio: 2) , screen and (-webkit-device-pixel-ratio:1.5)"
          />
          <link
            rel="shortcut icon"
            type="image/png"
            href="assets/images/bot.ico"
          />
          <link
            rel="stylesheet"
            type="text/css"
            href="//netdna.bootstrapcdn.com/bootstrap/3.1.1/css/bootstrap.min.css"
          />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          <link href="assets/css/menu-items.css" rel="stylesheet" />
          <link href="assets/css/horizantal-line.css" rel="stylesheet" />
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link
            href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css"
            rel="stylesheet"
          />
          <link rel="stylesheet" href="plugins/select2/select2.min.css" />
          <link rel="stylesheet" href="assets/css/ReactToastify.css" />
          <link rel="stylesheet" href="assets/css/drop-down-alignment.css" />
          <link rel="stylesheet" href="plugins/select2/css/select2.min.css" />
          <link rel="stylesheet" href="assets/css/select2.min.css" />
          <link rel="stylesheet" href="assets/css/flaticon.css" />
          <link rel="stylesheet" href="assets/css/index.css" />
          <link rel="stylesheet" href="assets/css/modal-style.css" />
          <link href="assets/css/material.css" rel="stylesheet" />
          <link href="assets/css/bootstrap.min.css" rel="stylesheet" />
          <link href="react-table-without-pagination.css" rel="stylesheet" />
          <link href="assets/css/div-as-input-field.css" rel="stylesheet" />
          <div className="row" style={{ marginLeft: "15px" }}>
            <div className="col-sm-4" style={{ marginTop: "2px" }}></div>
          </div>

          <div className="row" style={{ marginLeft: "14px" }}>
            <div className="col-sm-2">
              <h6
                className="nav-item"
                style={{ color: "#282a65", marginTop: "1vh" }}
              >
                View Survey
              </h6>
            </div>
            <div className="col-sm-8"
              Align="right" style={{ marginLeft: "-6vw" }}>
              <label
                style={{
                  display:
                    window.SCOPE_VALUE.CURRENT >
                      window.SCOPE_VALUE.HEALTHSYSTEM_ADMIN
                      ? "inline"
                      : "none",
                }}
              >
                Health System
              </label>

              <select
                value={this.state.selectedHealthSystemId}
                id="healthSystemId"
                className="healthSystem"
                onChange={(e) => this.onHealthSystemChange(e)}
                placeholder="Select Health System"
                ref={this.healthSystemDropDownInMARef}
                style={{
                  display:
                    window.SCOPE_VALUE.CURRENT >
                      window.SCOPE_VALUE.HEALTHSYSTEM_ADMIN
                      ? "inline"
                      : "none",
                  height: "30px",
                  borderRadius: "4px",
                  backgroundColor: "#F9F9FB",
                  width: "13vw",
                  marginLeft: "10px",
                }}
              >
                {this.state.healthSystemGroupValue.map((healthSystem) => (
                  <option value={healthSystem.value}>
                    {healthSystem.name}
                  </option>
                ))}
              </select>
              <label
                style={{
                  marginLeft: "3vh",
                  display:
                    window.SCOPE_VALUE.CURRENT >
                      window.SCOPE_VALUE.HOSPITAL_ADMIN
                      ? "inline"
                      : "none",
                }}
              >
                Hospital
              </label>

              <select
                value={this.state.selectedHospitalId}
                id="hospitalDropDown"
                className="hospital"
                onChange={(e) => this.onHospitalChange(e)}
                placeholder="Select hospital"
                ref={this.hospitalDropDownInMARef}
                style={{
                  display:
                    window.SCOPE_VALUE.CURRENT >
                      window.SCOPE_VALUE.HOSPITAL_ADMIN
                      ? "inline"
                      : "none",
                  height: "30px",
                  borderRadius: "4px",
                  backgroundColor: "#F9F9FB",
                  width: "13vw",
                  marginLeft: "10px",
                }}
              >
                {this.state.hospitalGroupValue.map((hospitalGroup) => (
                  <option value={hospitalGroup.value}>
                    {hospitalGroup.name}
                  </option>
                ))}
              </select>

              <label
                style={{
                  marginLeft: "3vh",
                  display:
                    window.SCOPE_VALUE.CURRENT >
                      window.SCOPE_VALUE.SERVICELINE_ADMIN
                      ? "inline"
                      : "none",
                }}
              >
                Service Line
              </label>
              <select
                value={this.state.selectedServiceLineId}
                id="serviceLine"
                className="hospital"
                onChange={(e) => this.onServiceLineChange(e)}
                placeholder="Select serviceline"
                ref={this.seriviceLineDropDownInMARef}
                style={{
                  display:
                    window.SCOPE_VALUE.CURRENT >
                      window.SCOPE_VALUE.SERVICELINE_ADMIN
                      ? "inline"
                      : "none",
                  height: "30px",
                  borderRadius: "4px",
                  backgroundColor: "#F9F9FB",
                  width: "13vw",
                  marginLeft: "10px",
                }}
              >
                {this.state.serviceLineGroupValue.map((serviceLineGroup) => (
                  <option value={serviceLineGroup.value}>
                    {serviceLineGroup.name}
                  </option>
                ))}
              </select>

            </div>
            <div className="col-sm-2 " style={{ marginTop: "-18px", marginLeft: "3vw" }}>
              <div className="d-flex flex-row-reverse pt-2"
                style={{ marginTop: "-0.7vh" }}
              >
                <div className="p-2"
                  style={{
                    marginBottom: "25px", display: "flex",
                    alignItems: "center"
                  }}>
                  <input
                    type="text"
                    style={{
                      width: "10vw",
                      border: "1px solid #777676",
                      borderRadius: "3px",
                      padding: "10px",
                      height: "0.6vw",
                      paddingRight: "2rem",
                    }}
                    value={this.state.searchTerm}
                    onChange={this.handleSearch}
                    placeholder="Search ..."
                  />
                  {this.state.searchTerm && (
                    <span
                      onClick={() => this.clearSearchData()}
                      style={{
                        // position: "absolute",
                        right: "8px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "#777676",
                        fontSize: "1.2rem",
                        fontWeight: "bold",
                        // lineHeight: 1,
                        userSelect: "none",
                        marginLeft: "-1vw"
                      }}
                    >
                      ×
                    </span>
                  )}

                  <button
                    title="Refresh"
                    onClick={this.refreshData}
                    type="button"
                    className="btn action-button"
                    style={{ marginLeft: "1vw" }}
                  >
                    <img src="./assets/images/refresh_white_24dp.png"></img>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            className="modal"
            style={{
              display: this.state.showPatientDetailsPopUp ? "flex" : "none",
              justifyContent: "center", alignItems: "center"
            }}
          >
            <div className="modal-dialog" id="center-aligned-account-modal" style={{ marginTop: "-12rem", marginLeft: "15rem" }} >
              <div
                className="modal-content"
                style={{
                  // position: "absolute",
                  marginTop: "37vh",
                  marginLeft: "7vh",
                  transform: "translate(7%, -7%)",
                  height: "auto",
                  width: "60vw",
                  overflowY: "scroll"
                }}
                Align="center"
              >
                <div className="modal-header noBorder">
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    id="close_id"
                    onClick={() => this.closePatientDataPopUp()}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                    >
                      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                      <path d="M0 0h24v24H0z" fill="none" />
                    </svg>
                  </button>
                </div>
                <div className="modal-body">
                  <ManageTabSettings
                    data={this.state.patientId}
                    isActive={defaultActiveTab}
                    onActiveClick={this.onActiveClick}
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            className="modal"
            style={{ display: this.state.showQrCode ? "block" : "none" }}
          >
            <div
              className="modal-dialog"
              id="center-aligned-account-modal"
              style={{ marginTop: "-13vh" }}
            >
              <div
                className="modal-content"
                style={{
                  height: "auto",
                  marginTop: "10vw",
                  width: "33vw",
                  marginLeft: "19vw",
                }}
                Align="center"
              >
                <div className="modal-header noBorder">
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    id="close_id"
                    onClick={this.closeQrCodePage}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                    >
                      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                      <path d="M0 0h24v24H0z" fill="none" />
                    </svg>
                  </button>
                </div>
                <div className="modal-body">
                  <h5 Align="center">On-boarding QR</h5>
                  <form ref={(el) => (this.myFormRef = el)}>
                    <a
                      href={
                        "https://www.myjeeva.net/?token=" + this.state.patientId
                      }
                      target="_blank"
                    >
                      <img
                        id="qr_code"
                        src={this.state.qrCode}
                        style={{
                          width: "21vw",
                          marginLeft: "-1vw",
                          height: "21vw",
                        }}
                      />
                    </a>
                  </form>
                  <p>
                    <b>Note: </b>Please open your My JEEVA app and scan the
                    On-boarding QR
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            className="row"
            style={{ marginLeft: "15px", marginTop: "-15px" }}
          >
            <div className="col-lg-12 ">
              {!this.state.noMatchingData && <div
                className="card"
                style={{ display: this.state.showLoader ? "block" : "none" }}
              >
                {this.state.isLoading && (
                  <div style={{ padding: '20px', textAlign: 'center' }}>
                    <p>Loading ...</p>
                  </div>
                )}
                {!this.state.isLoading && this.state.data.length === 0 && (
                  <div style={{ padding: '20px', textAlign: 'center' }}>
                    <p>There are no admission records to display </p>
                  </div>
                )}
                {this.state.data.length > 0 && (
                  <DataTable
                    data={this.state.data}
                    key={"table-" + this.state.pageNum}
                    pageSizeOptions={[5, 10, 15]}
                    onChangePage={this.onPageChange}
                    paginationDefaultPage={this.state.pageNum || 1}
                    columns={this.getColoumns()}
                    fixedHeaderScrollHeight="400px"
                    pagination={this.state.paginationValue}
                    noDataComponent={<this.CustomNoDataComponent />}
                  />)}
              </div>}
              <ToastContainer className="Toast-at-center" />
            </div>
          </div>
          <div className='card'>
            {this.state.noMatchingData &&
              <div style={{ padding: '20px', textAlign: 'center', boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
                <p>No matching options found ...</p>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

export default ViewSurvey;



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/ViewSurvey.js